import { gql } from '@apollo/client';

export const PREVIEW_CUSTOM_NOTIFICATION_ATHLETE_COUNT = gql`
  query PreviewCustomNotificationAthleteCount(
    $input: PreviewCustomNotificationInput!
  ) {
    previewCustomNotificationAthleteCount(input: $input)
  }
`;
